import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog } from '@sas/nova-commons/components/Dialog';
import { SectionState } from '../../store/section/SectionState';
import { useI18n } from '../../locale/I18nContext';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReportSection } from '../ReportSection';
import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { PromptContainerPopoverRootProvider } from '../PromptContainer';
export const HiddenSectionDialogBase = ({ actions, hiddenSection, onContextMenu, reportBackgroundColor, }) => {
    var _a;
    const localize = useI18n();
    const dt = useDesignTokens();
    return (_jsx(Dialog, Object.assign({ theme: reportBackgroundColor
            ? () => {
                // Apply report background to the full dialog
                // NOVACOMMONS-21838: type assertion needed because the types are missing some tokens
                return { '--dialog-content-bg': reportBackgroundColor };
            }
            : undefined, isOpen: !!hiddenSection, title: (_a = hiddenSection === null || hiddenSection === void 0 ? void 0 : hiddenSection.label) !== null && _a !== void 0 ? _a : '', dismissAction: {
            text: localize({ key: 'HiddenSectionDialog.close.txt' }),
            onPress: () => actions.closeHiddenSection(),
        }, contentPadding: 0, resizable: true, 
        // Disabled animation to avoid dialog content sizing issue (VASDK-657)
        // FIXME: only disable in tests
        hideAnimation: true, footerControls: (hiddenSection === null || hiddenSection === void 0 ? void 0 : hiddenSection.exportEnabled) ? (_jsx(Button, { style: { marginLeft: dt.tokens['space-base-m'] }, variant: ButtonVariant.Light, text: localize({ key: 'HiddenSectionDialog.export.txt' }), onPress: () => actions.notifyExportHiddenSection({ id: hiddenSection.id }) })) : undefined }, hiddenSection, { children: hiddenSection && (_jsx(PromptContainerPopoverRootProvider
        // PromptContainerPopoverRoot can't be used in a Dialog because both
        // the PromptContainer's button and its child popovers render in the
        // default popover root, leaving no possible layer for a custom root.
        //
        // In VA, the two features don't need to work together -
        // PromptContainerPopoverRootProvider is used to prevent
        // PromptContainers from overlapping the side panels in edit mode, and
        // HiddenSectionDialog is only used in view mode.
        , Object.assign({ 
            // PromptContainerPopoverRoot can't be used in a Dialog because both
            // the PromptContainer's button and its child popovers render in the
            // default popover root, leaving no possible layer for a custom root.
            //
            // In VA, the two features don't need to work together -
            // PromptContainerPopoverRootProvider is used to prevent
            // PromptContainers from overlapping the side panels in edit mode, and
            // HiddenSectionDialog is only used in view mode.
            value: null }, { children: _jsx(ReportSection, { data: hiddenSection, style: { height: '100%', boxSizing: 'border-box', lineHeight: 'normal' }, onContextMenu: onContextMenu }) }))) })));
};
export const HiddenSectionDialog = connect((state) => {
    var _a;
    return ({
        hiddenSection: state.sections.hiddenSection,
        reportBackgroundColor: (_a = state.bird.reportBackgroundColor) !== null && _a !== void 0 ? _a : undefined,
    });
}, (dispatch) => ({ actions: bindActionCreators(SectionState.actions, dispatch) }))(HiddenSectionDialogBase);
